import { render, staticRenderFns } from "./StudentManage.vue?vue&type=template&id=34ebb637&scoped=true"
import script from "./StudentManage.vue?vue&type=script&lang=js"
export * from "./StudentManage.vue?vue&type=script&lang=js"
import style0 from "./StudentManage.vue?vue&type=style&index=0&id=34ebb637&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ebb637",
  null
  
)

export default component.exports